import styled from "styled-components";
import {getTheme} from "../shared/themeUtils";
import {useMessages} from "../hooks/useMessages";
import Button from "./Button";
import Icon from "./Icon";
import {NotFoundType} from "../shared/enums";

const Contain = styled.div`
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${getTheme("space.3")} 0 ${getTheme("space.4")};
    text-align: center;

    .err-img {
        width: 80%;
        max-width: 300px;
    }

    h2 {
        position: relative;
        padding-bottom: 0;
        color: ${getTheme("colors.secondaryFont")};
    }

    p {
        color: ${getTheme("colors.secondaryFont")};
        position: relative;
        bottom: ${getTheme("space.2")};
    }

    button {
        display: flex;
        align-items: center;
    }
`

export type NotFoundProps = {
  type: NotFoundType.GENERAL | NotFoundType.PRODUCT | NotFoundType.CATEGORY | NotFoundType.BRAND | NotFoundType.SERIES | NotFoundType.JOB
}

export default function NotFound(props: NotFoundProps) {
  const {type} = props;
  const messagesQuery = useMessages()

  return (
    <div className="appContainer">
      {messagesQuery.data &&
        <Contain>
          <img src={"/client-images/404-error.svg"} className="err-img"/>

          {type == NotFoundType.PRODUCT &&
            <>
              <h2>{messagesQuery.data.messages["product-not-found-title"]}</h2>
              <p>{messagesQuery.data.messages["product-not-found-text"]}</p>
            </>
          }

          {type == NotFoundType.CATEGORY &&
            <>
              <h2>{messagesQuery.data.messages["category-not-found-title"]}</h2>
              <p>{messagesQuery.data.messages["category-not-found-text"]}</p>
            </>
          }

          {type == NotFoundType.JOB &&
            <>
              <h2>{messagesQuery.data.messages["job-not-found-title"]}</h2>
              <p>{messagesQuery.data.messages["job-not-found-text"]}</p>
            </>
          }

          {type == NotFoundType.BRAND &&
            <>
              <h2>{messagesQuery.data.messages["brand-not-found-title"]}</h2>
              <p>{messagesQuery.data.messages["brand-not-found-text"]}</p>
            </>
          }

          {type == NotFoundType.SERIES &&
            <>
              <h2>{messagesQuery.data.messages["series-not-found-title"]}</h2>
              <p>{messagesQuery.data.messages["series-not-found-text"]}</p>
            </>
          }

          {type == NotFoundType.GENERAL &&
            <>
              <h2>{messagesQuery.data.messages["page-not-found"]}</h2>
              <p>{messagesQuery.data.messages["page-not-found-text"]}</p>
              <Button variant={"secondary"} onClick={() => window.history.go(-2)}>
                <Icon>arrow-left-line</Icon>
                {messagesQuery.data.messages["back"]}
              </Button>
            </>
          }

          {type != "general" &&
            <Button variant={"secondary"} onClick={() => window.history.go(-1)}>
              <Icon>arrow-left-line</Icon>
              {messagesQuery.data.messages["back"]}
            </Button>
          }
        </Contain>
      }
    </div>
  )
}